import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container--navigation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation_tab_bar_item = _resolveComponent("navigation-tab-bar-item")!
  const _component_navigation_tab_bar = _resolveComponent("navigation-tab-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, {
    class: _normalizeClass(["main-page-container container", {'menu-active': _ctx.menuActive}])
  }, {
    default: _withCtx(() => [
      (!_ctx.topMenuHidden && !_ctx.hideNav)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_navigation_tab_bar, {
              "model-value": _ctx.$route.name
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parent.children, (route) => {
                  return (_openBlock(), _createBlock(_component_navigation_tab_bar_item, {
                    name: route.name,
                    onTabClick: ($event: any) => (_ctx.$router.push(route))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(route.meta.title ? route.meta.title : route.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["name", "onTabClick"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["model-value"])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "pre", {}, undefined, true),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_router_view)
      ], true),
      _renderSlot(_ctx.$slots, "post", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["class"]))
}